import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { LinearStepInfo } from '@core/components/linear-step-info/linear-step-info.interfaces';
import { PvDefaultLinearStepInfoComponent } from '@core/components/pv-default-linear-step-info/pv-default-linear-step-info.component';

@Component({
  selector: 'pv-default-header',
  standalone: true,
  imports: [CommonModule,PvDefaultLinearStepInfoComponent],
  templateUrl: './pv-default-header.component.html',
  styleUrl: './pv-default-header.component.scss',
})
export class PvDefaultHeaderComponent {
  @Input({ required: false }) title: string = '';
  @Input({ required: false }) voucherData: any;
  @Input() linearSteps: LinearStepInfo[] = [];
  @Input() copy:boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['linearSteps']) {
      this.linearSteps = changes['linearSteps'].currentValue;
    }
  }
}
